import React from 'react';

import * as D from './deps';
import Reducer from './reducer';
import OfferSagas from './sagas/watchers';
import {
  getAuthCampaignCopy,
  getSpecialOfferCampaignId,
  getSpecialOfferCode,
  getSpecialOfferDiscountType,
  getSpecialOfferPlanName,
  getSpecialOfferStatus,
  getSpecialOfferTier,
  isInSpecialOfferFlow,
} from './selectors';
import { getSpecialOfferErrorData } from './utils';

export default D.createDomainModule({
  name: 'specialOffers',
  components: {
    ProcessSpecialOffer: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_offer_process-special-offer" */ './components/ProcessSpecialOffer/ProcessSpecialOffer',
            )
          }
        />
      );
    },
    CongratulationsPage: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_offer_congratulations-page" */ './components/CongratulationsPage/CongratulationsPage',
            )
          }
        />
      );
    },
    Redeem: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(/* webpackChunkName: "c_offer_redeem" */ './components/Redeem/Redeem')
          }
        />
      );
    },
  },
  reducer: Reducer,
  selectors: {
    _specialOffers_: {
      getSpecialOfferCode,
      getSpecialOfferTier,
      getSpecialOfferDiscountType,
      isInSpecialOfferFlow,
      getSpecialOfferPlanName,
      getSpecialOfferStatus,
      getAuthCampaignCopy,
      getSpecialOfferCampaignId,
    },
  },
  utils: {
    _specialOffers_: {
      getSpecialOfferErrorData,
    },
  },
  persisted: true,
  onStart() {
    this.registeredHandlers = D.registerHandlers(OfferSagas);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
